import { FC } from 'react';
import { useDeepLinkHandler } from '../hooks/useDeepLinkHandler';

/**
 * Mounts the deep-link handler for the `balloon-events://` custom URL scheme.
 * Renders nothing — side-effects only.
 *
 * Handles:
 * - `balloon-events://balloons/new` → opens the QuickCreate modal
 *
 * Links can be triggered via:
 * - `<a href="balloon-events://balloons/new">` anywhere on the page
 * - `window.dispatchEvent(new CustomEvent('balloonevents:deeplink', { detail: url }))`
 * - Native Capacitor `appUrlOpen` (bridged from site/src/main.tsx)
 */
export const DeepLinkHandler: FC = () => {
    useDeepLinkHandler();
    return null;
};
